const objectToFormData = obj => {
  const formData = new FormData()
  for (const key in obj) {
    const value = obj[key]
    if (value !== '' && value !== null && value !== undefined) {
      formData.append(key, obj[key])
    }
  }
  return formData
}

export { objectToFormData }
